export const CREATING_CATEGORY_TYPE = "CREATING_CATEGORY_TYPE";
export const UPDATING_CATEGORY_TYPE = "UPDATING_CATEGORY_TYPE";
export const CATEGORY_TYPE_CREATED = "CATEGORY_TYPE_CREATED";
export const CATEGORY_TYPE_UPDATED = "CATEGORY_TYPE_UPDATED";
export const ERROR_CATEGORY_TYPE_CREATE = "ERROR_CATEGORY_TYPE_CREATE";
export const ERROR_CATEGORY_TYPE_UPDATE = "ERROR_CATEGORY_TYPE_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
